import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { OrganizationsService } from 'src/app/modules/organizations/services/organizations.service';
import { MdrDashboardsService } from '../../../services/mdr-dashboards.service';
import { MdrDashboardsIndicatorDataInterface } from '../../../interfaces/mdr-dashboards-indicator-data.interface';
import { of } from 'rxjs';
import { DataResponse } from '../../../interfaces/mdr-dashboards.data-response.interface';

@Component({
    selector: 'app-mdr-dashboards-indicator',
    templateUrl: './mdr-dashboards-indicator.component.html',
    styleUrls: ['./mdr-dashboards-indicator.component.scss'],
    standalone: false,
})
export class MdrDashboardsIndicatorComponent implements AfterViewInit {
    @HostBinding('className') componentClass: string;

    /**
     * @var element - element object passed from the tab's component.
     * This object will contain specific settings and custom options for the bar chart widget
     */
    @Input() element: MdrDashboardsIndicatorDataInterface;

    @Input() barchartToIndicatorConversion = false;
    @Input() barchartToIndicatorConversionTargets: string[] = [];

    @Input() titleMarginBottom = 0;

    /* @var defaultEmptyValue - what to show on empty/error state */
    @Input() defaultEmptyValue = '- -';

    /**  loading - enable/disable loading state for this specific indicator */
    @Input() loading = false;
    @Input() alterateDataWithValue: number = 0;
    public hideDrilldownTitle = true;

    public constructor(
        public organizationService: OrganizationsService,
        public mdrDashboardsService: MdrDashboardsService,
        public cdr: ChangeDetectorRef,
    ) {
        this.componentClass = 'item';
    }

    public ngAfterViewInit() {
        if (this.barchartToIndicatorConversion && this.barchartToIndicatorConversionTargets.length) {
            this.element.data.subscribe((result) => {
                this.element.data = of({
                    company_id: result.company_id,
                    data: {
                        value: this.convertFromBarchartDatasource(result, this.barchartToIndicatorConversionTargets),
                    },
                    delta: result.delta,
                    end: result.end,
                    start: result.start,
                    timestamp: result.timestamp,
                    widget: result.widget,
                });
                this.cdr.detectChanges();
            });
        }
    }

    /**
     * Function to check if the object is empty or not
     * @param obj - object to check
     */
    public isEmptyObject(obj: {} | null) {
        if (!obj) {
            return true;
        }

        return obj && Object.keys(obj).length === 0;
    }

    public addDeltaSign(delta: number | undefined): string {
        if (typeof delta === 'undefined' || delta === null) {
            return '- -';
        }

        return delta > 0 ? '+' + delta + '%' : delta + '%';
    }

    public convertFromBarchartDatasource(data: DataResponse, categories: string[]): number {
        let index = -1;
        let sum = 0;

        categories.forEach((categoryName: string) => {
            data.data.forEach((arr: any) => {
                if (arr.name === categoryName) {
                    index = arr.data.findIndex((item: any) => item !== null);
                }
            });
            sum += data.data.find((category: any) => category.name === categoryName).data[index] ?? 0;
        });

        return sum;
    }
}
